import React from 'react';
import classNames from 'classnames';
import signupContext from 'src/constants/signupContext';
import SitebarDropdown from './sitebarDropdown';
import { connect } from 'react-redux';

import { HEALTH_TOPICS } from 'src/utils/healthCategoryUtil';

import {trackFootfallEvent} from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

import { showLoginModal, showSignupModal } from 'src/modules/shared/modal/actions';

import config from 'config/config';

import i18n from 'i18next';

const getSignupItems = () => [
  {
    key: 'find-others',
    name: i18n.t('Find Others'),
    element: signupContext.element.FIND_OTHERS_LINK,
    image: `${config.cdn.bg}FindOthers.svg`,
  },
  {
    key: 'quiz',
    name: i18n.t('Take a health needs quiz'),
    element: signupContext.element.TAKE_HEALTH_NEEDS_QUIZ_LINK,
    image: `${config.cdn.bg}HealthNeeds.svg`,
  },
  {
    key: 'ask-question',
    name: i18n.t('Ask a health question'),
    element: signupContext.element.ASK_HEALTH_QUESTION_LINK,
    image: `${config.cdn.bg}HealthQuestion.svg`,
  },
];

const VisitorMenu = ({ community, handleClick, open, showLoginModal, showSignupModal }) => {
  const communityClasses = classNames({
    'visitor-menu': true,
    'visitor-menu--open': open,
  });

  const iconClasses = classNames({
    'icon-close': open,
    'icon-menu-3': !open,
  });

  const searchText = community && community.name ? `${i18n.t('Search')} ${community.name}` : i18n.t('Search HealthUnlocked');
  const searchLink = community && community.communityId ? `/search/posts?page=1&community=${community.communityId}` : '/search/posts';

  return (
    <div className={communityClasses}>
      <a href="#" className="visitor-menu__heading hidden-xs" onClick={handleClick}><span className={iconClasses} />{i18n.t('Health tools and topics')}</a>
      <a href="#" className="visitor-menu__heading visible-xs" onClick={handleClick}><span className={iconClasses} />{i18n.t('Menu')}</a>
      <SitebarDropdown open={open} addScrollWhenExceedsViewport={true}>
        <a onClick={() => showLoginModal(false)} className="sitebar-dropdown__link">{i18n.t('Have an account? Log in')}</a>
        <div className="divider">
          {i18n.t('Health tools')}
        </div>
        <ul>
          {getSignupItems().map(item => (
            <li key={item.key} onClick={() => showSignupModal(false)}>
              <a>
                <img className="avatar avatar--xsmall" src={item.image}/>
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <div className="divider">
          {i18n.t('Health topics')}
        </div>
        <ul>
          {HEALTH_TOPICS.map(category => <li key={category.name}>
            <a href={category.link} onClick={() => {
              const element = category.name;
              trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'health-topics', element}, clickType: 'visitor-menu' });
            }}>
              <img className="avatar avatar--xsmall" src={category.imageThumb}/>
              {category.name}
            </a>
          </li>)}
        </ul>
        <a href={searchLink} className="sitebar-dropdown__search" onClick={() => {
          trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'search'}, clickType: 'visitor-menu' });
        }}>
          {searchText}
        </a>
      </SitebarDropdown>
    </div>
  );
};

export default connect(null, { showLoginModal, showSignupModal })(VisitorMenu);



// WEBPACK FOOTER //
// ./src/components/siteBar/visitorMenu.js